import React from 'react';
import { withTranslation } from 'react-i18next';

import CPGeneralInformationContainer
  from '../../ChemicalProduct/ChemicalProductDetails/GeneralInformation/CPGeneralInformationContainer';
import CPEnvironmentalInformationContainer
  from '../../ChemicalProduct/ChemicalProductDetails/EnvironmentalInformation/CPEnvironmentalInformationContainer';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { Grid} from 'semantic-ui-react';
import CPValidateInformationContainer from './ValidateInformation/CPValidateInformationContainer';
import connect from 'react-redux/es/connect/connect';
import { batch } from 'react-redux';
import { debounce } from 'lodash-es';
import { risksActions } from '../../../behavior/risks';
import CPSelectChemicalContainer from './CPSelectChemicalContainer';
import { CREATE_MODE, VIEW_MODE } from '../../../constants';
import ChemicalProductDetailsTitleContainer from './ChemicalProductDetailsTitleContainer';
import { getSelectedChemProdProps } from '../../../utils';
import CPRemarksContainer from './OtherInformation/CPRemarksContainer';
import { AccordionWrapper } from 'react-lib/dist/components-es';

class ChemicalProductDetailsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    if (props.values.chemicalProduct) this.setSelectedChemicalProduct(props.values.chemicalProduct);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.chemicalProduct && this.props.chemicalProduct != newProps.chemicalProduct)
      this.updateChemicalProduct(newProps.chemicalProduct);
  }

  setSelectedChemicalProduct(newChemicalProduct) {
    const { values, setFieldValue } = this.props;
    values.chemicalProduct.selectedChemicalProduct = getSelectedChemProdProps(newChemicalProduct);
    setFieldValue(
      'chemicalProduct.selectedChemicalProduct',
      values.chemicalProduct.selectedChemicalProduct
    );
  }

  updateChemicalProduct = chemicalProduct => {
    if (
      (!chemicalProduct.selectedChemicalProduct || !chemicalProduct.selectedChemicalProduct.id) &&
      chemicalProduct.id
    )
      chemicalProduct.selectedChemicalProduct = getSelectedChemProdProps(chemicalProduct);
    this.props.setFieldValue('chemicalProduct', chemicalProduct);

    this.debouncedUpdateRiskCalculations();
  };

  updateRiskCalculations = () => {
    batch(() => {
      this.props.envRiskCalculation();
      this.props.chemRiskCalculation();
    });
  };

  debouncedUpdateRiskCalculations = debounce(this.updateRiskCalculations, 500);

  chemicalProductDisabled = () => {
    const { currentStep, isChemProdRouter, mode } = this.props;
    const { selectedChemicalProduct } = this.props.values.chemicalProduct;
    return (
      !isChemProdRouter &&
      ((mode == CREATE_MODE && currentStep > 1) ||
        (selectedChemicalProduct && selectedChemicalProduct.id != -1))
    );
  };

  render() {
    const { values, t, mode, isChemProdRouter, currentStep, isHistory } = this.props;
    if (!values.chemicalProduct) values.chemicalProduct = { state: {}, liquidCategory: {} };
    const { selectedChemicalProduct } = values.chemicalProduct;

    let isInvCreateStep2NewChem =
      mode == CREATE_MODE &&
      currentStep > 1 &&
      selectedChemicalProduct &&
      (!selectedChemicalProduct.id || selectedChemicalProduct.id === -1);

    //selection NOT visible on: chem prod router OR view mode generally OR on inv create mode when on step 2
    let displaySelectChemProd = !(isChemProdRouter || mode == VIEW_MODE || isInvCreateStep2NewChem);
    let displayChemProd =
      !displaySelectChemProd || (selectedChemicalProduct && selectedChemicalProduct.id);
    let isChemicalProductDisabled = this.chemicalProductDisabled();

    return (
      <>
        <ChemicalProductDetailsTitleContainer
          chemicalProduct={values.chemicalProduct}
          isChemProdRouter={isChemProdRouter}
          isHistory={isHistory}
          mode={mode}
        />
        <AccordionWrapper
          {...this.props}
          accordionTitle={t('chemical.product.details.page.chemical.product.details.container.title')}
          className="containerReducedWhiteSpace"
          render={props => (
            <Grid doubling columns={1}>
              <Grid.Column>
                {displaySelectChemProd && <CPSelectChemicalContainer {...props} collapsed={false} />}
                {displayChemProd && (
                  <>
                    <CPGeneralInformationContainer
                      {...props}
                      collapsed={false}
                      chemicalProductDisabled={isChemicalProductDisabled}
                      debouncedUpdateRiskCalculations={this.debouncedUpdateRiskCalculations}
                    />
                    <CPEnvironmentalInformationContainer
                      {...props}
                      collapsed={false}
                      chemicalProductDisabled={isChemicalProductDisabled}
                    />
                    <CPRemarksContainer
                      {...props}
                      collapsed={false}
                      chemicalProductDisabled={isChemicalProductDisabled}
                    />
                    <CPValidateInformationContainer
                      {...props}
                      collapsed={false}
                      chemicalProductDisabled={isChemicalProductDisabled}
                    />
                  </>
                )}
              </Grid.Column>
            </Grid>
          )
          }/>
      </>
    );
  }
}

ChemicalProductDetailsContainer.defaultProps = {
  isChemProdRouter: false
};

const mapStateToProps = state => ({
  chemicalProduct: state.chemicalProducts.chemicalProduct
});

const mapDispatchToProps = dispatch => ({
  envRiskCalculation: () => dispatch(risksActions.envRiskCalculation()),
  chemRiskCalculation: () => dispatch(risksActions.chemRiskCalculation())
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation(),
  withRouter
)(ChemicalProductDetailsContainer);
